import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dark-swtich-btn" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-moon" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

import { ref } from "vue";
import { useDarkModeStore } from "@/stores";


export default /*#__PURE__*/_defineComponent({
  __name: 'LightDarkSwtichBtn',
  setup(__props) {

const isDarkMode = ref(localStorage.getItem('dark') ? localStorage.getItem('dark') : true );
if(isDarkMode.value === true || isDarkMode.value === false)
  document.body.classList.toggle('dark', isDarkMode.value);
const toggleDarkMode = () => {
  isDarkMode.value = !isDarkMode.value;
  useDarkModeStore().toggleDarkMode();
  document.body.classList.toggle('dark', isDarkMode.value);
  localStorage.setItem('dark', isDarkMode.value.toString());
};
const storedDarkMode = localStorage.getItem('dark');
if (storedDarkMode) {
  isDarkMode.value = storedDarkMode === 'true';
  document.body.classList.toggle('dark', isDarkMode.value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: "switch-toggle transition d-inline-block position-relative border-0 rounded-circle",
      id: "switch-toggle",
      onClick: toggleDarkMode
    }, _hoisted_3)
  ]))
}
}

})